<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_v"></a><span class="smallcaps">On the</span><br/>Steamy Side</h1>
<p class="author">L O U I S A  E D W A R D S</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.gif"/></p>
<p class="editor1">St. Martin’s Paperbacks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b7129eb4